export type NativeJobsSectionTextDirection = {
  textAlign: "left" | "right";
  writingDirection: "ltr" | "rtl";
};

export function getNativeJobsSectionTextDirection(
  isRTL: boolean,
): NativeJobsSectionTextDirection {
  return {
    textAlign: isRTL ? "right" : "left",
    writingDirection: isRTL ? "rtl" : "ltr",
  };
}

export function getWebJobsSectionDirection(isRTL: boolean): "ltr" | "rtl" {
  return isRTL ? "rtl" : "ltr";
}
